<li class="nav-item">
  <button (click)="cancel()" class="btn btn-danger text-white me-2" href="#"><i class="fa fa-window-close" aria-hidden="true"></i> {{ "cancelAction" | language }}</button>
</li>
